import React from 'react'
import type { Icon } from 'shared/utils'

const Bag = (props: Icon) => {
    const {
        color = 'black',
        size = 12,
        className = 'bag',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={(size * 17) / 12}
            className={className}
            viewBox="0 0 12 17"
            {...otherProps}>
            <g fill={color} fillRule="evenodd">
                <path d="M2.739 2.903a.94.94 0 00-1.125-.328l-.328.147c-.385.172-.6-.02-.478-.425L1.324.586a.836.836 0 01.969-.567l6.522 1.493c.41.094.59.48.399.858l-.6 1.185c-.192.378-.592.441-.89.142l-.213-.214a.972.972 0 00-1.179-.117l-.021.014a.896.896 0 01-1.141-.152.938.938 0 00-1.157-.177l-.182.112a.802.802 0 01-1.078-.238l-.014-.022z" />
                <path d="M11.748 9.971a4.873 4.873 0 00-.384-1.484l-.413-.872a7.208 7.208 0 01-.476-1.473l-.365-1.979c-.078-.422-.175-.418-.217.01L9.63 6.886c-.041.427-.081.797-.088.822-.007.026-.165.363-.351.75l-.087.18a3.938 3.938 0 00-.327 1.484l.053 3.43c.006.428.257.526.556.217 0 0 .21-.217.84-.223.314 0 .652.11.99.347a.273.273 0 01.065.382.276.276 0 01-.383.065l-.268-.187c-.222-.033-.701.13-1.064.363 0 0-.433.277-.63.68l-.068.13a1.435 1.435 0 01-.175.25h-.11a.326.326 0 01-.052-.004l-.129-.024c-.052-.133-.1-.592-.107-1.021l-.068-4.46c-.007-.43-.01-.8-.008-.823.003-.023.175-.397.36-.784l.094-.194a5.271 5.271 0 00.414-1.48l.275-2.834c.042-.427-.07-.457-.25-.067l-.324.703c-.179.39-.575.461-.88.158l-.463-.461a1.002 1.002 0 00-1.206-.12l-.023.015a.923.923 0 01-1.167-.154.996.996 0 00-1.194-.194l-.167.097c-.373.215-.876.116-1.12-.22-.243-.336-.513-.267-.6.153l-.285 1.373c-.088.42-.391 1.028-.675 1.351l-.251.286c-.284.322-.532.937-.551 1.366L0 12.78c-.02.429.297.898.703 1.042l6.775 2.408c.406.144 1.056.112 1.446-.072l2.415-1.14c.39-.184.686-.685.658-1.113l-.25-3.934z" />
            </g>
        </svg>
    )
}

export { Bag }
